import React from 'react';
import AsyncSelect from 'react-select';
import connect from "react-redux/es/connect/connect";
import {injectIntl} from "react-intl";

class BankCoSelect extends React.Component {

    constructor(params) {
        super(params);
        this.selectRef = React.createRef();
        let companies = this.props.constants.codes.bank_cos
            .filter((bank) => Date.parse(bank.begin) <= Date.now() && Date.parse(bank.end) >= Date.now())
            .map((state) => { return { value: state.key, label: `${state.value} (${state.key.substring(2)})` }});

        this.state = {
            inputValue: '',
            value: companies.filter((country) => country.value === this.props.value),
            initial: true,
            companies: companies
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const { value, inputValue } = this.state;

        if ( value && nextProps.value !==  value.value ) {
            this.setState({ initial: true });
        }
    }

    handleInputChange = (newValue) => {
        this.setState({ inputValue: newValue });
        return newValue;
    };

    handleChange = (change) => {
        this.setState({ value: change });
        this.props.onChange(change ? change.value : null);
    };

    render() {
        const isClearable = this.state.value && this.state.value.value && this.state.value.value !== '';

        return (
            <AsyncSelect
                inputProps={{ autoComplete: 'off', autoCorrect: 'off', spellCheck: 'off' }}
                autocomplete={false}
                // key={this.props.value}
                // ref={this.selectRef}
                className='user-select-container'
                classNamePrefix='user-select'
                options={this.state.companies}
                // onInputChange={this.handleInputChange}
                onChange={this.handleChange}
                value={ this.state.value }
                isDisabled={this.props.disabled}
                // inputValue={ this.state.inputValue }
                // isClearable={ isClearable }
            />
        );
    }
}


function mapStateToProps(state,ownProps) {
    return {
        constants: state.constants,
    };
}

export default injectIntl(connect(mapStateToProps)(BankCoSelect));
